import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { store } from 'store';
import App from 'App';
import 'global/fonts.css';
import 'global/styles.css';
import 'global/variables.css';

if (!!+process.env.PRODUCTION) {
    ReactGA.initialize(process.env.GOOGLE_ANALYTICS_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);